import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './index.module.scss'
import AMap from '../../../components/amap'
import PoiSearch from './PoiSearch'
import AutoComplete from './AutoComplete'
import AmapMarker from './AmapMarker'
import request from '../../../network/request'
import MessageBox from '../../../components/message-box'
import CommonLoading from '../../../components/CommonLoading'
import useAppLocationData from '../store/useAppLocationData';

import usePickupAddress from '../store/usePickupAddress'
import useGetCh from '../../../hooks/useGetCh'
import { reportUserBehavior } from '../../../utils/report'
import { convertAdcode } from '../../../utils/common';
import { sendReport } from '../../../utils/reporter';
import useHashModal from '../../../hooks/useHashModal'
import useReserveStoreInfo from '../hooks/useReserveStoreInfo'
import { DEFAULT_CITY } from '../config/constants'

export default function () {
  const history = useHistory()
  const ch = useGetCh()
  const { appLocationData } = useAppLocationData();
  const [inputKeyword, setInputkeyword] = useState('')
  const [clickKeyword, setClickKeyword] = useState('')
  const [clickAdcode, setClickAdcode] = useState(0)
  const [suggestList, setSuggestList] = useState<any>([])
  const [addressList, setAddressList] = useState<any>([])
  const [selectAddress, setSelectAddress] = useState<any>({})
  const [showSuggest, setShowSuggest] = useState(false);
  const [initLngLat, setInitLngLat] = useState<number[]>([0, 0]);
  // 当前选中门店信息
  const reserveStoreInfo = useReserveStoreInfo();

  const { setPickupAddress } = usePickupAddress()

  const { visible } = useHashModal('#select-address', {
    title: '取车地点',
    onShow: () => {
      reportUserBehavior(
        {
          so: 'J001005',
          mcode: 'maintence_address',
          ch,
          pa: `status=success`,
        },
        'page'
      )
    }
  });

  useEffect(() => {
    if (appLocationData?.address && appLocationData.adCode) {
      setClickAdcode(Number(appLocationData.adCode));
      setShowSuggest(false);
      setInitLngLat([appLocationData.coords.longitude, appLocationData.coords.latitude]);
    }
  }, [appLocationData]);

  useEffect(() => {
    if (inputKeyword?.length === 0) {
      setSuggestList([])
      setAddressList([])
      setSelectAddress({})
      setClickKeyword('')
    }
  }, [inputKeyword])
  
  const handleInput = (event) => {
    setInputkeyword(event.target.value)
  }

  const handleSearched = (list) => {
    setAddressList(list)
    setSelectAddress({})
  }

  const handleSetSuggestion = (list) => {
    setSuggestList(list)
    if (list?.length > 0 && !showSuggest) {
      setShowSuggest(true)
    }
  }

  const handleSelectSuggest = (item) => {
    setShowSuggest(false)
    setClickKeyword(item.name)
    setClickAdcode(item.adcode || 0)
  }

  const handleSelectAddress = (address) => {
    setSelectAddress(address);
    handleSure(address);
  }

  const handleSure = async targetAddress => {
    sendReport({
      mcode: "取送车地址列表选择点击",
      point: 'P11183`B028',
    })
    console.log('targetAddress ...... ', targetAddress);
    if (!targetAddress.name || !targetAddress?.location) {
      MessageBox.toast('请搜索并选择取车地点')
      return
    }

    const { adcode } = targetAddress;
    const [provinceCode, cityCode] = convertAdcode(adcode);
    console.log('即将对比 cityCode, ', typeof cityCode, ':', cityCode, ',', typeof reserveStoreInfo?.cityCode, ':', reserveStoreInfo?.cityCode)
    console.log('还有 provinceCode 为', provinceCode);
    // 不支持异地取送车，直辖车 cityCode 只有2位，跟省编码一致
    if (`${cityCode}` !== `${reserveStoreInfo?.cityCode}` && `${provinceCode}` !== `${reserveStoreInfo?.cityCode}`) {
      MessageBox.toast('不支持跨城取送车~');
      console.error('不支持跨城取送车~！', typeof cityCode, typeof reserveStoreInfo?.cityCode)
      return;
    }
    console.log('对比 cityCode 通过~')

    CommonLoading.show();
    try {
      const drivingInfo: any = await request(
        'module/maintenance/driving/opt',
        {
          drivingCityCode: targetAddress?.adcode,
          drivingCityName: targetAddress?.cityname,
        },
        'POST'
      )

      if (drivingInfo?.isDriving === 1) {
        setPickupAddress({
          drivingPickupAddress: `${targetAddress.name} ${targetAddress.address}`,
          drivingPickupAddressLat: targetAddress?.location?.lat,
          drivingPickupAddressLng: targetAddress?.location?.lng,
          drivingPickupCityCode: targetAddress?.adcode,
          drivingPickupCityName: targetAddress?.cityname,
        })
        history.goBack()
      } else {
        MessageBox.alert('该城市没有取送车服务，请返回选择自驾到到店')
      }
      CommonLoading.hide();
    } catch (err) {
      CommonLoading.hide();
      MessageBox.toast((err as any).message || '网络异常请稍后重试')
    }
  }

  const onSearchInputFocus = () => {
    sendReport({
      mcode: "输入框输入点击",
      point: 'P11187`B001',
    })
  }

  if (!visible) return null;

  return (
    <div className={styles.pagePickupAddress}>
      <div className={styles.mapContainer}>
        {
          reserveStoreInfo && (
            <AMap>
              <AutoComplete
                city={reserveStoreInfo?.city || DEFAULT_CITY }
                keyword={inputKeyword}
                onSearched={handleSetSuggestion}
              ></AutoComplete>
              <PoiSearch
                lnglat={initLngLat}
                cityCode={reserveStoreInfo.cityCode}
                keyword={clickKeyword}
                adcode={clickAdcode}
                onSearched={handleSearched}
              ></PoiSearch>
              <AmapMarker
                pickupPosition={{
                  lng: selectAddress?.location?.lng,
                  lat: selectAddress?.location?.lat,
                }}
              ></AmapMarker>
            </AMap>
          )
        }
      </div>
      <div className={styles.searchBar}>
        <input
          className={styles.keywordInput}
          placeholder="搜索地点"
          type="text"
          value={inputKeyword}
          onChange={handleInput}
          onFocus={onSearchInputFocus}
        />
      </div>
      {
        showSuggest && suggestList.length > 0 && (
            <div className={styles.suggestContainer}>
              {
                suggestList.map((item, index) => {
                  return item.district ? (
                    <div
                      className={styles.suggestItem}
                      key={index}
                      onClick={() => handleSelectSuggest(item)}
                    >
                      <div className={styles.icon}></div>
                      <div className={styles.info}>
                        <div className={styles.name}>{item.name}</div>
                        <div className={styles.district}>{item.district}</div>
                      </div>
                    </div>
                  ) : null
                })
              }
            </div>
          )
      }
      <div className={styles.addressContainer}>
        <div className={styles.results}>
          {
            addressList && addressList.length > 0 ? (
              addressList.map((item) => {
                return (
                  <div
                    className={styles.addressItem}
                    key={item.id}
                    onClick={() => handleSelectAddress(item)}
                  >
                    <div
                      className={[
                        styles.radio,
                        selectAddress.id === item.id ? styles.selected : '',
                      ].join(' ')}
                    ></div>
                    <div className={styles.addressInfo}>
                      <h3 className={styles.addressTitle}>{item.name}</h3>
                      <p className={styles.addressdetail}>
                        {item.cityname} {item.adname} {item.address}
                      </p>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className={styles.searchTip}>
                <div className={styles.icon}></div>
                <div className={styles.tipTxt}>
                  请输入具体地点信息，如：广州亚运城
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}
